import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import jwt_decode from 'jwt-decode';

interface Permiso {
  exp: number;
  iat: number;
  id: number;
  id_user_erp: number;
  permisses: [];
  role_id: string;
  username: string;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  isSidebarPinned = false;
  isSidebarToggeled = false;
  public token = "";
  public listPermis: Permiso;
  public permisos_menu: number[] = []

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
  ) { }

  error(error){
    this.spinner.hide()
        if(error.status == 401){
         
          return Swal.fire({title:'Token inválido',text: '',icon: 'error',heightAuto: false}).then( data =>{
            localStorage.removeItem("token");
            window.location.reload()
          });
       
        }
        // else if(error.status == 403){
         
        //   return Swal.fire("Token sin permisos","", 'error').then( data =>{
        //     this.router.navigate(['/pdg/home']);
        //   });
       
        // }

        if(error.status == 500){
          
          return Swal.fire({title:"Error en el servidor",text: "intentelo más tarde",icon: 'error',heightAuto: false}).then( data =>{
          //this.router.navigate(['/pdg/home']);
          });
       
        }
        
        Swal.fire({title:error.error.message,text: '',icon: 'error',heightAuto: false});
  }

  getPermisses() {
    this.token = localStorage.getItem('token')
    this.listPermis = jwt_decode(this.token);


    this.listPermis.permisses.map((dato) => {


      if (dato > 0) {


        if (this.permisos_menu.find(element => element == dato)) {

        } else {
          this.permisos_menu.push(Number(dato))
        }
      }

    });
    this.permisos_menu = this.permisos_menu.sort((a, b) => a - b);
    return this.permisos_menu;
    
  }
  error2(error){
    if(error == 403){
         
      Swal.fire({title:"Sin permisos",text: '',icon: 'error',heightAuto: false}).then( data =>{
        this.router.navigate(['/pdg/home']);
      });
   
    }
  }

}